import { ErrorMessage, useField } from 'formik'
import React, { Children, cloneElement, isValidElement } from 'react'

// Huelle jedes Feldes der Backoffice-Formulare (#77).
//
// Die Beschriftung steht ueber dem Feld, der Fehler darunter — und beides ist
// vom Feld aus erreichbar: ein Fehler, der nur daneben steht, erreicht
// niemanden, der das Feld ueber die Tastatur ansteuert. Die Verknuepfung
// braucht ein aria-describedby am Eingabefeld selbst, darum wird das Kind
// ergaenzt, wenn es ein einzelnes Element ist.
//
// Pflicht wird als aria-required gesetzt, nicht als required: das native
// Attribut wuerde die Pruefung des Browsers dazwischenschalten, waehrend die
// Formulare mit yup pruefen.
const FieldWrapper = ({
    id,
    displayName,
    typeClass,
    children,
    required = false,
    // Erklaerender Satz ueber dem Feld. Bewusst getrennt vom displayName: der
    // baut in manchen Feldern auch den Placeholder (FieldSelectItems).
    hint = false,
    classNamePrefix = 'client-form'
}) => {
    const [, meta] = useField(id)

    const hintId = hint ? `${id}-hint` : false
    const errorId = meta.touched && meta.error ? `${id}-error` : false
    const describedBy = [errorId, hintId].filter(Boolean).join(' ')

    const child = Children.count(children) === 1 && isValidElement(children)
        ? cloneElement(children, {
            ...(describedBy && { 'aria-describedby': describedBy }),
            // Ein fehlerhaftes Feld sagt es auch selbst (Stufe 2 Barrierefreiheit).
            ...(errorId && { 'aria-invalid': 'true' }),
            ...(required && { 'aria-required': 'true' })
        })
        : children

    return (
        <div className={`field-wrapper ${typeClass} ${id}`}>
            <label className={classNamePrefix + '-label'} htmlFor={id}>
                {displayName}
                {required && <span className="field-required" title="Pflichtfeld" aria-hidden="true">*</span>}
            </label>

            <div className={classNamePrefix + '-field'}>
                {hint && <p className={classNamePrefix + '-hint'} id={hintId}>{hint}</p>}

                {child}

                {errorId && (
                    <ErrorMessage className="error-box" name={id} component="div" id={errorId} />
                )}
            </div>
        </div>
    )
}

export default FieldWrapper
